export default __webpack_public_path__ + "static/media/circle-fiolet.c89ca5c8.svg";